import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import { useState } from 'react';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapFloatingLabelInput = React.lazy(function () {
    return import('../../bootstrap-components/components/BTFloatingLabelInput');
});
var bootStrapfloatinglabelinput = function (props) {
    var _a = useState(false), fieldactivated = _a[0], setFieldActivated = _a[1];
    var callingOnChange = function (event) {
        props.onChange(event.target.value);
    };
    var activateField = function () {
        setFieldActivated(true);
    };
    var disableFocus = function () {
        if (props.value === '') {
            setFieldActivated(false);
        }
    };
    return (React.createElement(BootStrapFloatingLabelInput, __assign({}, props, { onChange: function (e) { return callingOnChange(e); }, styleName: props.hasError ? 'danger' : props.styleName, ioMode: props.ioMode, onFocus: activateField, onBlur: function (e) { return disableFocus(); }, fieldactivated: fieldactivated })));
};
var FloatingLabelInput = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapfloatinglabelinput(props);
            break;
        default:
            componentToDisplay = bootStrapfloatinglabelinput(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
FloatingLabelInput.defaultProps = {
    styleName: 'primary',
    name: 'FloatingLabelInput',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default FloatingLabelInput;
//# sourceMappingURL=FloatingLabelInput.js.map